import React from 'react';
import {
  IonIcon,
  IonLabel,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonRouterOutlet
} from '@ionic/react';
import { calendar, podium, woman, qrCode, person, cash } from 'ionicons/icons';
import { connect } from 'react-redux'
import './UserProgress.css';

import { Route, Redirect } from "react-router";

import InfoUser from './InfoUser';
import Program from './Program';
import Results from './Results';
import Punctuation from './Punctuation';
import Tutor from './Tutor';
import Pay from './Pay';

import IndexActions from '../../../actions/index';

interface Props {
}

interface ClassState {
  data: any;
  match: any;
}

class UserProgress extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  render() {
    const { child } = this.state.match.params;
    return (
      <IonTabs>

        <IonRouterOutlet>
          <Route path="/progress/:child/info" component={InfoUser}  />
          <Route path="/progress/:child/pro" component={Program} />
          <Route path="/progress/:child/result" component={Results} />
          <Route path="/progress/:child/note" component={Punctuation} />
          <Route path="/progress/:child/doc" component={Tutor} />
          <Route path="/progress/:child/pay" component={Pay} />
          <Route path="/" render={() => <Redirect to="/progress/:child/info" />} exact={true} /> 
        </IonRouterOutlet>

        <IonTabBar slot="bottom" style={{ overflow: 'scroll', justifyContent: 'left' }}>
          <IonTabButton tab="progress/info" href={`/progress/${ child }/info`}>
            <IonIcon icon={person} />
            <IonLabel>Información</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/pro" href={`/progress/${ child }/pro`}>
            <IonIcon icon={calendar} />
            <IonLabel>Programación</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/result" href={`/progress/${ child }/result`}>
            <IonIcon icon={podium} />
            <IonLabel>Resultados</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/note" href={`/progress/${ child }/note`}>
            <IonIcon icon={qrCode} />
            <IonLabel>Notas</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/doc" href={`/progress/${ child }/doc`}>
            <IonIcon icon={woman} />
            <IonLabel>Docentes</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/pay" href={`/progress/${ child }/pay`}>
            <IonIcon icon={cash} />
            <IonLabel>Pagos</IonLabel>
          </IonTabButton>
        </IonTabBar>

      </IonTabs>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMe: () => dispatch(IndexActions.getMe())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProgress);
